'use strict';

var button = {};

exports.__exports = button;
//# sourceMappingURL=button.cjs.map
